import React from "react";
import { motion } from "framer-motion";
import { SITE } from "../../../lib/siteData";
import { fadeUp } from "../../../lib/motion";

export default function TeamSection() {
  return (
    <section id="team" className="py-24 sm:py-32 bg-[#011233]" data-testid="team-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <motion.div {...fadeUp} className="text-center mb-16">
          <p className="text-[12px] uppercase tracking-[0.36em] text-[#B5BAC2] font-semibold">
            Meet the team
          </p>
          <h2 className="mt-5 font-heading font-bold text-3xl sm:text-5xl text-white tracking-tight">
            The people behind your peace of mind.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8">
          {SITE.team.map((m, i) => (
            <motion.div
              key={m.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 }}
              whileHover={{ y: -6 }}
              className="kn-card-blue group rounded-[28px] bg-white overflow-hidden ring-1 ring-[#011233]/10"
              data-testid={`team-member-${i}`}
            >
              <div className="aspect-[5/6] overflow-hidden bg-[#F0F0F2]">
                <img
                  src={m.image}
                  alt={m.name}
                  className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.05]"
                />
              </div>
              <div className="p-7">
                <p className="text-[11px] uppercase tracking-[0.22em] text-[#011233] font-semibold">
                  {m.role}
                </p>
                <h3 className="mt-2 font-heading font-bold text-xl text-slate-900 tracking-tight">
                  {m.name}
                </h3>
                <div className="mt-4 space-y-1.5 text-[13px] text-slate-600">
                  <a
                    href={`mailto:${m.email}`}
                    className="block hover:text-[#011233] transition-colors break-all"
                  >
                    {m.email}
                  </a>
                  {m.phone && <p className="text-slate-500">{m.phone}</p>}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
